import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RECAPTCHA_LANGUAGE, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { ComponentsModule } from '@components/components.module';
import { ToastsModule } from '@components/toasts/toasts.module';
import { AppConfigService } from '@services/app-config.service';
import { TokenInterceptor } from '@services/token.interceptor';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

const appInitializerFn = (appConfig: AppConfigService) => () => appConfig.loadConfig();

export function getReCaptchaSiteKey(appConfigService: AppConfigService) {
  return appConfigService.config.captchaSiteKey;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    ToastsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    ComponentsModule,
    BrowserAnimationsModule,
    RecaptchaV3Module
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'en'
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: getReCaptchaSiteKey,
      deps: [AppConfigService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
